import React from "react";
import { Row, Col, Typography } from "antd";
import "./herosection.style.css";
import sdgood from "../../assets/banner/sandee_good.png";
import { AuroraText } from "../AuroraText/AuroraText";

const { Text } = Typography;

const HeroSection = () => {
  return (
    <div className="hero-container">
      <Row className="hero-content">
        <Col xs={24} sm={24} md={10} lg={10} xl={10} className="hero-image-container">
          <div className="hero-image">
            <img src={sdgood} alt="Customer service chatbot" />
          </div>
        </Col>
        <Col xs={24} sm={24} md={14} lg={14} xl={14} className="hero-text-container">
          <div className="hero-text">
            <div className="hero-subtitle">
              <img className="hero-subtitle-icon" src={sdgood} alt="Customer service chatbot" />
              <Text className="hero-subtitle-name">CUSTOMER SERVICE</Text>
            </div>
            {<AuroraText className="hero-main-title" colors={["#E4002B", "#2C74B3", "#ff1f1f"]}>
              SANDEE CHATBOT
            </AuroraText>}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default HeroSection;
